// extracted by mini-css-extract-plugin
export var menuIcon = "_nv-0";
export var menuIconInline = "_nv-1";